export default {"src":"/_next/static/media/SPY.e2e232a9.svg","height":18,"width":18};